/**
 * Blynex Theme JavaScript Entry Point
 * 
 * This file serves as the main entry point for all JavaScript functionality
 * in the Blynex theme. It imports and initializes various feature modules.
 * 
 * @package Blynex
 * @since 1.0.0
 */

// Import element hide functionality for editor
import './features/element-hide';

// Import hover effect functionality for blocks
import './features/hover-effect';